import { EventEmitter, Injectable } from '@angular/core';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { Capacitor } from '@capacitor/core';

@Injectable()
export class FirebaseService {
    public static token: any;
    public newNetification: EventEmitter<any> = new EventEmitter();

    constructor() {
        if (Capacitor.isNativePlatform()) {
            this.registerEventEmitters();
        }
    }

    public registerEventEmitters() {
        if (Capacitor.isNativePlatform()) {
            FirebaseMessaging.requestPermissions().catch(err => console.error(err));

            FirebaseMessaging.getToken()
                .then(result => (FirebaseService.token = result.token))
                .catch(err => console.error(err));

            FirebaseMessaging.addListener('tokenReceived', event => {
                FirebaseService.token = event.token;
            });

            FirebaseMessaging.addListener('notificationReceived', event => {
                const notification = event.notification;
                let message: any = {};
                try {
                    message = JSON.parse((notification.data as any)?.['message'] ?? '{}');
                } catch (e) {
                    message = notification.data ?? {};
                }
                message['appWasClosed'] = false;
                console.log(message, notification);
                this.newNetification.emit(message);
            });

            FirebaseMessaging.addListener('notificationActionPerformed', event => {
                console.log(event);
                const notification = event.notification;
                let message: any = {};
                try {
                    message = JSON.parse((notification.data as any)?.['message'] ?? '{}');
                } catch (e) {
                    message = notification.data ?? {};
                }
                message['appWasClosed'] = true;
                console.log(notification);
                message.tap = true;
                message.url = notification.data?.['url'] ?? null;
                this.newNetification.emit(message);
            });
        }
    }

    public subscribeToTopic(topicName: string) {
        if (Capacitor.isNativePlatform()) {
            FirebaseMessaging.subscribeToTopic({ topic: topicName }).catch(err => console.error(err));
            if (!FirebaseService.token) {
                FirebaseMessaging.getToken()
                    .then(result => (FirebaseService.token = result.token))
                    .catch(err => console.error(err));
            }
        }
    }

    public unregisterFromAllTopics() {
        if (Capacitor.isNativePlatform()) {
            FirebaseMessaging.removeAllListeners().then(() => setTimeout(() => this.registerEventEmitters(), 3500));
        }
    }

    public deleteToken() {
        if (Capacitor.isNativePlatform()) {
            FirebaseMessaging.deleteToken().catch(err => console.error(err));
        }
    }
}
